import ReactDOM from "react-dom/client";
import AppRoutes from "./routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "styles/utils.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<AppRoutes />);
